import ReactDOM from 'react-dom/client';
import App from './App';
import wrapWithProviders from 'utils/wrapWithProviders';
import RootErrorBoundary from 'components/UI/ErrorBoundary/RootErrorBoundary';
import { setupStore } from 'store/store.js';
import { bootstrapBugWidget } from 'components/bugWidget/bootstrapBugWidget';
import { pruneExpiredDiscardedForms } from 'utils/discardedFormCache';
import './config/sentry';
import './index.css';

// Reap any discarded-form snapshots whose TTL has elapsed (e.g. transactions
// that were discarded but never reopened) so stale operator data doesn't linger.
pruneExpiredDiscardedForms();

async function enableAPIMocking() {
    if (import.meta.env.VITE_MSW !== 'enabled') return;
    const { worker } = await import('./mocks/browser/serviceWorker.js');
    return worker.start({
        onUnhandledRequest() {}, //disable warnings for unhandeled requests
    });
}

const store = setupStore();
const root = ReactDOM.createRoot(document.getElementById('root'));
enableAPIMocking().then(() => {
    root.render(<RootErrorBoundary>{wrapWithProviders(<App />, { store })}</RootErrorBoundary>);

    window.setTimeout(() => {
        bootstrapBugWidget({ store });
    }, 0);
});
